import { ElementRef } from '@angular/core';
import { forOwn } from 'lodash';
import { setCssProperty } from '../../../../../cross-team-shared/misc-utils';

export const SharedFusionCssProperties = {
  'output-thumbnail-width': '300px',
  'output-thumbnail-container-height': '140px',
  'output-thumbnail-title-height': '30px',
};

export function getSharedFusionCssNumericProperty(
  propertyName: keyof typeof SharedFusionCssProperties,
) {
  return parseInt(SharedFusionCssProperties[propertyName], 10);
}

export function setSharedFusionCssProperties(
  elementRef: ElementRef<HTMLElement> | ElementRef<SVGElement>,
) {
  const prefix = '--ursa--';
  forOwn(SharedFusionCssProperties, (value, key) => {
    setCssProperty(elementRef, prefix + key, value);
  });
}
